export const FUND_SUMMARY_SPREADSHEET_HEADER_TITLE = 'FUND_SUMMARY_SPREADSHEET_HEADER_TITLE';
export const FUND_SUMMARY_SPREADSHEET_SUBHEADER_TITLE = 'FUND_SUMMARY_SPREADSHEET_SUBHEADER_TITLE';
export const FUND_SUMMARY_SPREADSHEET_TOTAL = 'FUND_SUMMARY_SPREADSHEET_TOTAL';
export const FUND_SUMMARY_SPREADSHEET_DIRECT_INVESTMENTS_TOTAL = 'FUND_SUMMARY_SPREADSHEET_DIRECT_INVESTMENTS_TOTAL';
export const FUND_SUMMARY_SPREADSHEET_FUND_INVESTMENTS_TOTAL = 'FUND_SUMMARY_SPREADSHEET_FUND_INVESTMENTS_TOTAL';
